import { Box, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const BlockchainCardWrapper = styled(Box)`
  background: ${({ theme }) =>
    `linear-gradient(304deg, ${getThemeColor('secondary', theme)} -1.45%, ${getThemeColor('primary', theme)} 103.12%);`};
`

export const StyledLink = styled.a`
  width: 100%;
`
